import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/core/store/store'

const licenses = (state: RootState) => state.licensesReducer
export const licensesSelector = createSelector(
  licenses,
  licensesReducer => licensesReducer.licenses,
)

const companystatistic = (state: RootState) => state.licensesReducer
export const companystatisticSelector = createSelector(
  companystatistic,
  licensesReducer => licensesReducer.companystatistic,
)
